import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d467f9ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "carousel" }
const _hoisted_2 = { class: "carousel-inner" }
const _hoisted_3 = { class: "carousel-indicators" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 0,
  class: "first-text"
}
const _hoisted_6 = { class: "title" }

import {
  reactive,
  onMounted,
  onBeforeUnmount,
  PropType,
} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Carousel',
  props: {
  carouselData: {
    type: Array as PropType<
      {
        describe: any;
        image: string;
      }[]
    >,
    default: () => [],
    required: true,
  },
  // textStyle: {
  //   type: String,
  //   required: true,
  // },
},
  setup(__props) {

const props = __props;
const state = reactive({
  currentIndex: 0,
  startX: 0,
});
const handleIndicatorClick = (index: number) => {
  state.currentIndex = index;
};
onMounted(() => {
  const interval = 3000;
  const timer = setInterval(() => {
    const nexIndex = (state.currentIndex + 1) % props.carouselData.length;
    state.currentIndex = nexIndex;
  }, interval);

  onBeforeUnmount(() => {
    clearInterval(timer);
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.carouselData, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(['carousel-item', { active: index === state.currentIndex }])
        }, [
          _createElementVNode("div", {
            style: _normalizeStyle({ backgroundImage: `url(${item.image})` }),
            class: "d-block w-100"
          }, null, 4)
        ], 2))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.carouselData, (item, index) => {
        return (_openBlock(), _createElementBlock("span", {
          key: index,
          class: _normalizeClass(['indicator', { active: index === state.currentIndex }]),
          onClick: ($event: any) => (handleIndicatorClick(index))
        }, null, 10, _hoisted_4))
      }), 128))
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.carouselData, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "indicator-container",
        key: index
      }, [
        (index === state.currentIndex)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(item.describe.title), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.describe.introduction
            .split('【')
            .join('\n【')
            .split('\n'), (paragraph, paragraphIndex) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "desc",
                  key: paragraphIndex
                }, [
                  (paragraph.trim() !== '')
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 0,
                        class: _normalizeClass({ paragraph: paragraphIndex !== 0 })
                      }, _toDisplayString(paragraph), 3))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}
}

})